import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  updateMessageStatusRequest,
  updateMessageStatusSuccess,
  updateMessageStatusFailure,
} from '../reducers/message';
import { messagesListRequest } from '../reducers/messagesList';
import { messageContentRequest } from '../reducers/messageContent';
import { API_LINK } from '../../constants';
import { announcementsRequest } from '../reducers/announcements';

const API = `${API_LINK}api/announcement/`;

function* updateMessageStatusFunctionAxios() {
  const state = yield select(fullState => fullState);
  const { token } = state.loginReducer;
  const messageId =
    state.messageContentReducer.selectedMessageId || state.teamMembersFullReducer.selectedMessageId;
  const status = state.messageReducer.statusAction;
  const response = yield call(() =>
    axios({
      method: 'put',
      url: `${API}${messageId}/status`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      data: {
        status,
      },
    }),
  );

  return response;
}

function* workerUpdateMessageStatusSaga() {
  try {
    const response = yield call(updateMessageStatusFunctionAxios);
    const responseFromUpdateMessageStatus = response.data;
    const state = yield select(fullState => fullState);

    if (response.status === 200) {
      yield put(updateMessageStatusSuccess(responseFromUpdateMessageStatus));
      yield put(announcementsRequest());
      yield put(messagesListRequest());
      // yield put(messageContentRequest(state.teamMembersFullReducer.selectedMessageId));
    }

    if (response.status === 203) {
      yield put(updateMessageStatusFailure(response.statusText));
    }

    if (response.status === 205) {
      yield put(updateMessageStatusFailure(response.statusText));
    }

    if (response.status === 500) {
      yield put(updateMessageStatusFailure(response.statusText));
    }
  } catch (error) {
    yield put(updateMessageStatusFailure(error));
  }
}

export function* watcherUpdateMessageStatusSaga() {
  yield takeLatest(updateMessageStatusRequest().type, workerUpdateMessageStatusSaga);
}
